import { render, staticRenderFns } from "./CoinsV2.vue?vue&type=template&id=741c71c2&"
import script from "./CoinsV2.vue?vue&type=script&lang=ts&"
export * from "./CoinsV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports